"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CheckboxGroup = void 0;
const lit_1 = require("lit");
const decorators_js_1 = require("lit/decorators.js");
const if_defined_js_1 = require("lit/directives/if-defined.js");
const repeat_js_1 = require("lit/directives/repeat.js");
const checkbox_styles_1 = require("@/components/common/checkbox/checkbox.styles");
const input_styles_1 = require("@/components/common/input/input.styles");
const multiple_selection_controller_1 = require("@/controllers/multiple-selection-controller");
const shared_styles_1 = require("@/stylesheets/shared.styles");
const utils_1 = require("@/utils");
require("@/components/common/text");
// mm-radio-group처럼 mm-checkbox를 감싸지 않고, 공유 스타일 모듈(checkboxStyles)을 조합해 input을 직접 렌더한다.
// 그래야 선택 상태를 shadow 경계 없이 그룹이 온전히 소유한다.
let CheckboxGroup = class CheckboxGroup extends lit_1.LitElement {
    constructor() {
        super(...arguments);
        this.options = [];
        this.values = [];
        this.size = 'medium';
        // shadow 안에서만 쓰는 label 연결용 id라 호스트의 id와 섞지 않는다.
        this.idPrefix = (0, utils_1.uniqueId)('checkbox-group');
        this.selection = new multiple_selection_controller_1.MultipleSelectionController({
            getValues: () => this.values,
            setValues: values => {
                this.values = values;
            },
            getOptions: () => this.options,
        });
    }
    render() {
        return (0, lit_1.html) `
      <fieldset>
        ${this.renderLegend()}
        ${(0, repeat_js_1.repeat)(this.options, option => option.value, option => this.renderOption(option))}
      </fieldset>
    `;
    }
    renderLegend() {
        if (!this.legend)
            return lit_1.nothing;
        return (0, lit_1.html) `
      <legend>${this.legend}</legend>
    `;
    }
    renderOption(option) {
        const inputId = `${this.idPrefix}-${option.value}`;
        return (0, lit_1.html) `
      <input
        type="checkbox"
        id=${inputId}
        name=${(0, if_defined_js_1.ifDefined)(this.name)}
        .value=${option.value}
        .checked=${this.selection.isOptionSelected(option)}
        ?disabled=${option.disabled}
        @change=${() => this.handleOptionChange(option)}
      />
      <label for=${inputId}>
        <span class="indicator"></span>
        <mm-paragraph>${option.label}</mm-paragraph>
      </label>
    `;
    }
    get checked() {
        return this.selection.isAllSelected();
    }
    get indeterminate() {
        return this.selection.isPartiallySelected();
    }
    toggleAll() {
        this.selection.setAllSelected(!this.checked);
        this.dispatchValueChange();
    }
    handleOptionChange(option) {
        this.selection.select(option);
        this.dispatchValueChange();
    }
    dispatchValueChange() {
        (0, utils_1.emit)(this, 'change', { values: this.values });
    }
};
CheckboxGroup.styles = [
    shared_styles_1.resetStyles,
    input_styles_1.visuallyHiddenInputStyles,
    input_styles_1.inputSelectionGroupStyles,
    checkbox_styles_1.checkboxStyles,
];
__decorate([
    (0, decorators_js_1.property)({ attribute: false })
], CheckboxGroup.prototype, "options", void 0);
__decorate([
    (0, decorators_js_1.property)({ attribute: false })
], CheckboxGroup.prototype, "values", void 0);
__decorate([
    (0, decorators_js_1.property)({ type: String })
], CheckboxGroup.prototype, "name", void 0);
__decorate([
    (0, decorators_js_1.property)({ type: String, reflect: true })
], CheckboxGroup.prototype, "size", void 0);
__decorate([
    (0, decorators_js_1.property)({ type: String })
], CheckboxGroup.prototype, "legend", void 0);
CheckboxGroup = __decorate([
    (0, decorators_js_1.customElement)('mm-checkbox-group')
], CheckboxGroup);
exports.CheckboxGroup = CheckboxGroup;
//# sourceMappingURL=data:application/json;base64,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